// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"forgot-password-m__wrapper__1o7Qg","actions-wrapper":"forgot-password-m__actions-wrapper__1j0_H"};